import { Link } from 'react-router-dom';

const DigitalAssetsPreview = () => {
  const assets = [
    {
      name: 'KL Carpool',
      url: 'www.klcarpool.com',
      tagline: 'Sustainable Mobility for Modern Cities',
      description: 'Real-time ride-matching platform with corporate carpool programs and ESG-focused sustainability initiatives.',
      features: ['Real-time Matching', 'Corporate Programs', 'ESG Reporting'],
      icon: 'ri-car-line',
      image: 'https://public.readdy.ai/ai/img_res/148b8e7137ecddff5711eb90ec68fbd0.jpg',
      linkText: 'Visit Platform',
      linkUrl: 'https://www.klcarpool.com',
    },
    {
      name: 'Drixem Palm Oil B2B E-Marketplace',
      url: 'www.drixems.com',
      tagline: 'Next-Gen Trading Hub',
      description: 'Direct mill-to-buyer platform with live pricing, transparent inventory management, and integrated Exim Bank financing.',
      features: ['Live Pricing', 'Transparent Inventory', 'Integrated Financing'],
      icon: 'ri-shopping-cart-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20laptop%20displaying%20modern%20B2B%20e-commerce%20marketplace%20dashboard%20with%20clean%20interface%20showing%20product%20listings%20pricing%20charts%20and%20inventory%20data%20on%20desk%20in%20bright%20Malaysian%20office%20environment%20contemporary%20business%20technology%20photography%20style%20with%20palm%20oil%20trading%20theme&width=800&height=600&seq=marketplace-my-v2&orientation=landscape',
      linkText: 'Visit Platform',
      linkUrl: 'https://www.drixems.com',
    },
    {
      name: 'AI Branding & Marketing for SME',
      url: '',
      tagline: 'Maximize Sales Across Every E-Commerce Channel',
      description: 'Physical AI-powered branding and marketing platform for SME companies, leveraging TikTok Shop, Shopee, Lazada, and e-commerce channels to drive maximum sales and brand visibility.',
      features: ['TikTok Shop', 'Shopee & Lazada', 'Physical AI'],
      icon: 'ri-store-3-line',
      image: 'https://readdy.ai/api/search-image?query=Close%20up%20screenshot%20of%20TikTok%20Shop%20mobile%20app%20interface%20showing%20product%20listings%20with%20buy%20now%20buttons%20live%20shopping%20feature%20product%20cards%20with%20prices%20and%20shopping%20cart%20on%20smartphone%20screen%20bright%20colorful%20social%20commerce%20interface%20with%20orange%20and%20red%20TikTok%20branding%20elements%20professional%20app%20screenshot%20photography%20style&width=800&height=600&seq=tiktok-shop-actual-v2&orientation=landscape',
      linkText: 'Learn More',
      linkUrl: '/digital-assets',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-50 rounded-full mb-6">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-sm text-primary-700 font-medium">Live Digital Platforms</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4 sm:mb-6">
            Strategic Digital Assets
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Flagship AI-powered platforms generating <strong>recurring revenue</strong> and transforming traditional industries
          </p>
        </div>

        <div className="space-y-12">
          {assets.map((asset, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="w-full h-80">
                  <img
                    src={asset.image}
                    alt={asset.name}
                    className="w-full h-full object-cover object-top rounded-2xl shadow-xl"
                  />
                </div>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${asset.icon} text-2xl text-primary-600`}></i>
                  </div>
                  <span className="text-sm font-semibold text-primary-600 uppercase tracking-wide">
                    Digital Platform {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="text-3xl font-bold text-gray-900 mb-3">
                  {asset.name}
                </h3>

                <p className="text-lg font-semibold text-primary-600 mb-4">
                  {asset.tagline}
                </p>

                <p className="text-gray-600 mb-6 leading-relaxed">
                  {asset.description}
                </p>

                <div className="grid grid-cols-3 gap-4 mb-6">
                  {asset.features.map((feature, idx) => (
                    <div
                      key={idx}
                      className="bg-gray-50 rounded-lg p-4 text-center"
                    >
                      <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                        <i className="ri-check-double-line text-xl text-primary-600"></i>
                      </div>
                      <span className="text-xs font-medium text-gray-700">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
                  {asset.linkUrl.startsWith('http') ? (
                    <a
                      href={asset.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
                    >
                      <span>{asset.linkText}</span>
                      <i className="ri-external-link-line"></i>
                    </a>
                  ) : (
                    <Link
                      to={asset.linkUrl}
                      className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
                    >
                      <span>{asset.linkText}</span>
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  )}
                  <Link
                    to="/digital-assets"
                    className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span>View All Platforms</span>
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DigitalAssetsPreview;
